import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-enrolled-member-phone-change',
  templateUrl: './enrolled-member-phone-change.component.html',
  styleUrls: ['./enrolled-member-phone-change.component.scss']
})
export class EnrolledMemberPhoneChangeComponent implements OnInit {

  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  public newMemberData: any = {}
  apisub:Subscription
  constructor(private apiservice:ApiService,  @Inject(MAT_DIALOG_DATA) public parentdata:any, private loaderservice: LoaderServiceService, private activemodal: MatDialogRef<EnrolledMemberPhoneChangeComponent>, private dialog: MatDialog) {
    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SET_ENROLLED_MEMBER_PHONE_NUMBER){
        
        if(resdata.result){
          this.activemodal.close('success')
        }
      }
    })
   }

  ngOnInit(): void {
  }
    countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
    selectedCountryCode:any = this.countryList.find(country => country.dial_code === this.countryInfo.countryCode)
    searchString: FormControl = new FormControl('');
    onCountrySelected(event: any): void {
      this.searchString.reset()
      this.countryList = COUNTRY_CODES
    }
    formChecker(){
      if(this.newMemberData.customerPh){
        if(this.newMemberData.customerPh.length >= 3 && this.newMemberData.customerPh.length <= 17){
          return false
        }
        else{
          return true
        }
      }
      else{
        return true
      }
    }
    onKey() { 
      console.log(this.searchString.value);
      
      this.countryList= []; 
      this.selectSearch(this.searchString.value);       
    }
    selectSearch(value:string){
      let filter = value.toLowerCase();
      for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
          let option = COUNTRY_CODES[i];
          if (  option.name.toLowerCase().indexOf(filter) >= 0) {
              this.countryList.push( option );
          }
      }
    }
    onPost(){
      let data = {
        "memberHash": this.parentdata.memberHash,
        "countryCode": this.selectedCountryCode.dial_code,
        "phone": this.newMemberData.customerPh
      }

      console.log(data);
      this.loaderservice.showLoader = true
      this.apiservice.setEnrolledMemberPhoneNumber(data)
      
    }
}
